import type { PoiData } from '$lib/components/pois/types';

interface PopupState {
	activePoiId?: string;
	poi?: PoiData;
	open: boolean;
}

let popupState = $state<PopupState>({ activePoiId: undefined, poi: undefined, open: false });

export function usePopupState() {
	return {
		setPopupState: (state: PopupState) => {
			popupState = { ...popupState, ...state };
		},
		getPopupState: () => {
			return $state.snapshot(popupState);
		},
	};
}
